// src/data/coupangPicks.ts
//
// 쿠팡 파트너스 추천 상품 카드.
//
// 파트너스 > 링크 생성 에서 만든 https://link.coupang.com/a/XXXXXX 단축 URL을
// 상품명과 함께 넣으면, 해당 지원금(또는 분야) 상세 페이지 아래쪽에 카드로
// 나타납니다. title 이 비어 있는 항목은 렌더링되지 않습니다.
//
// ※ 정부지원금 정보와 섞이지 않도록 카드는 본문 맨 아래에만 노출되며,
//   공정위 대가성 문구가 항상 함께 표시됩니다.
// ※ 그 지원금을 받는 사람에게 실제로 쓸모 있는 물건만 넣으세요.
//   (예: 출산지원금 → 육아용품 / 에너지바우처 → 난방용품)
//
// 상품명이 확정되지 않은 일반 제휴 링크는 src/config/coupang.ts 의 COUPANG_LINKS 에
// 모아 두었고, 상세 페이지 배너 아래 텍스트 링크로 노출됩니다. 상품명을 알게 되면
// 그 링크를 아래 배열로 옮겨 카드로 보여주는 편이 클릭률이 높습니다.
//
import { CategoryId } from '../types';

export interface CoupangPick {
    /** 파트너스 링크 생성으로 만든 단축 URL (https://link.coupang.com/a/...) */
    url: string;
    /** 화면에 보일 상품명 — 비어 있으면 노출되지 않음 */
    title: string;
    /** 왜 이 지원금과 관련 있는지 한 줄 설명 (선택) */
    note?: string;
    /** 상품 이미지 URL (선택, 파트너스 링크 생성 화면에서 복사) */
    image?: string;
    /** 보조 표기 (선택). 가격은 자주 바뀌므로 넣지 않는 편을 권합니다. */
    badge?: string;
}

/**
 * 지원금 slug 별 추천 상품 (분야별 기본값보다 우선).
 * 예) 'chulsan-jiwongeum': [{ url: 'https://link.coupang.com/a/XXXXXX', title: '신생아 기저귀' }]
 */
export const picksByProgram: Record<string, CoupangPick[]> = {};

/** 분야별 기본 추천 상품 */
export const picksByCategory: Record<CategoryId, CoupangPick[]> = {
    worker: [],
    housing: [],
    parenting: [],
    education: [],
    business: [],
    welfare: [],
};

/** 해당 지원금에 보여줄 추천 상품 (상품명이 채워진 것만) */
export function getPicks(slug: string, category: CategoryId): CoupangPick[] {
    const own = picksByProgram[slug]?.filter(p => p.title && p.url) ?? [];
    if (own.length > 0) return own;
    return (picksByCategory[category] ?? []).filter(p => p.title && p.url);
}
